// frontend/admin-portal/src/services/roleService.js
import api from './axiosConfig';

export const roleService = {
    catalog: async () => {
        const { data } = await api.get('/roles/catalog');
        return data.data;   // { catalog, allKeys }
    },
    list: async () => {
        const { data } = await api.get('/roles');
        return data.data.roles;
    },
    get: async (id) => {
        const { data } = await api.get(`/roles/${id}`);
        return data.data;   // { role, users }
    },
    create: async (payload) => {
        const { data } = await api.post('/roles', payload);
        return data.data.role;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/roles/${id}`, payload);
        return data.data.role;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/roles/${id}`);
        return data;
    },
    duplicate: async (id) => {
        const { data } = await api.post(`/roles/${id}/duplicate`);
        return data.data.role;
    },
};